import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSubscription, selectUser } from '../../../reducers/user.selectors';
import { add as dateAdd } from 'date-fns';
import { ampliConversionPath, routes } from '../../../constants';
import services from '../../../services';
import { TopBarIconLink } from './TopBar';
import { useTranslation } from 'react-i18next';
import { Nav } from 'react-bootstrap';

const UpgradeCTA: React.FC<{ shouldRenderSeparator?: boolean }> = ({ shouldRenderSeparator }) => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const subscription = useSelector(getSubscription);
  const [hasUserSubscriptionForOver30Days, setHasUserSubscriptionForOver30Days] = useState(false);

  const canUserUpgradeToSchoolLicence = (user?.isDocumentUser || user?.isKombiUser)
    && !(user.isWalkIn || user?.isSchoolUser || user?.isTrial || user?.isLibraryUser);
  const shouldHideUpgradeToSchoolLicenceButton = (!canUserUpgradeToSchoolLicence || !hasUserSubscriptionForOver30Days);

  const trackAmplitudeEvent = () => {
    if (user && ampliConversionPath.NavigationBar) {
      services.track.ampliTrackPricingPlansViewedEvent(
        ampliConversionPath.NavigationBar,
        subscription?.status,
      );
    }
  };

  useEffect(() => {
    if (user && subscription) {
      const today = new Date();
      const subscriptionDatePlus30Days = dateAdd(new Date(subscription.originalStartDate), { days: 30 });
      setHasUserSubscriptionForOver30Days(subscription.status === 'Active' && today > subscriptionDatePlus30Days);
    }
  }, [user, subscription]);

  const renderUpgradeButton = () => {
    if (user?.canUpgrade) {
      return (
        <TopBarIconLink
          link={`/${routes.upgradePackageSelection.root}`}
          tooltip={t('Update Plan')}
        >
          <span 
            data-testid='top-bar__upgrade'
            className='top-bar__icon top-bar__premium-link' 
            onClick={trackAmplitudeEvent}
          >
            {t('Update Plan')}
          </span>
        </TopBarIconLink>
      );
    } else if (!shouldHideUpgradeToSchoolLicenceButton) {
      return (
        <TopBarIconLink
          link={`/${routes.upgradeToSchoolLicence.root}`}
          tooltip={t('School license information')}
        >
          <span className='top-bar__icon top-bar__premium-link'>
            {t('meinUnterricht')}
            <span
              data-testid='top-bar__school-licence'
              className='top-bar__premium-pill'
            >
              {t('SCHOOLS')}
            </span>
          </span>
        </TopBarIconLink>
      );
    }

    return null;
  };

  const upgradeCTA = renderUpgradeButton();
  
  return <>
    {upgradeCTA && shouldRenderSeparator && (
      <Nav.Item
        className='top-bar__icon top-bar__icon-container d-none d-md-flex'
        data-testid='top-bar__separator'>
        |
      </Nav.Item>
    )}
    {upgradeCTA}
  </>;
};

export default UpgradeCTA;
